import { render, staticRenderFns } from "./StatisticsMapModal.vue?vue&type=template&id=c9ff32e0"
import script from "./StatisticsMapModal.vue?vue&type=script&lang=js"
export * from "./StatisticsMapModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports